/*
 * -----------------------------------------------------------------------
 *  <copyright file="accept-organisation-invite.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Settings from '../../../settings/settings';
import Constants from '../../../utils/constants';
import Loading from '../../components/core/loading';
import ExistingUserInvitation from './existing-user-invitiation';
import NewUserInvitation from './new-user-invitation';
import { UserContext } from '@contexts/user-context';
import { useBoolean } from '@hooks/index';

const AcceptOrganisationInvite = () => {
    const { organisationId: organisationKey, memberId } = useParams();
    const { setUser, setToken } = useContext(UserContext);

    useEffect(() => {
        setUser(null);
        setToken(null);
    });

    const loading = useBoolean(true);
    const [error, setError] = useState();
    const [invite, setInvite] = useState(null);

    useEffect(() => {
        fetch(`${Settings.api.url()}/api/organisation-invite/${organisationKey}/${memberId}`)
            .then((result) => result.json())
            .then((invitation) => {
                if (invitation.error) setError(invitation.error);
                else {
                    setInvite(invitation);
                    setError(null);
                }
            })
            .catch((e) => {
                setError(e.message);
            })
            .finally(loading.setFalse);
    }, [memberId, organisationKey]);

    if (error) return <div>{error}</div>;

    if (loading.value || !invite) return <Loading />;

    if (!invite.member) return <div>Invalid registration.</div>;

    return invite.member.userId !== Constants.ObjectId.Empty ? (
        <ExistingUserInvitation
            id={invite.member.organisationId}
            member={invite.member}
            name={invite.organisationName}
        />
    ) : (
        <NewUserInvitation
            organisationKey={organisationKey}
            organisationCode={invite.loginCode}
            member={invite.member}
        />
    );
};

export default AcceptOrganisationInvite;
